import React from 'react';
import { Conversation } from './conversation';
import { CAFModalHandlers, ConversationObj, OptionClickInfo } from '../../../types/caf';

type Props = {
  modalRef: React.MutableRefObject<HTMLDivElement>;
  setHeight: React.Dispatch<React.SetStateAction<number>>;
  conversations: ConversationObj[];
  handlers: CAFModalHandlers;
};

export const ConversationsList = (props: Props): JSX.Element => {
  const { conversations, handlers } = props;
  const lastConversation = conversations[conversations.length - 1];
  const lastConversationId = lastConversation.conversationId;
  const dispatchBubbleActionClick = (info: OptionClickInfo): void => {
    const currentConversationId = info.conversationId;
    const isPreviousConversationClicked = lastConversation.conversationId !== currentConversationId;

    if (isPreviousConversationClicked) {
      handlers.previousConvOptionClicked(info);
    } else {
      handlers.optionClickHandler(info);
    }
  };

  return (
    <>
      {conversations?.map((item) => (
        <Conversation
          key={item.conversationId}
          isLastConversation = {item.conversationId === lastConversationId}
          conversationId={item.conversationId}
          conversation={item.conversation}
          contextMetaInfo={item?.contextMetaInfo || {}}
          handleOptionClick={dispatchBubbleActionClick}
          scrollToBottom={handlers?.scrollToBottom}
          modalRef={props?.modalRef}
          setHeight={props?.setHeight}
          totalConversations={conversations?.length}
        />
      ))}
    </>
  );
};
